// extracted by mini-css-extract-plugin
export var actions = "_lg-d";
export var benefitCard = "_lg-a";
export var benefitIcon = "_lg-b";
export var benefitLabel = "_lg-c";
export var benefits = "_lg-9";
export var bodyText = "_lg-8";
export var closeButton = "_lg-2";
export var content = "_lg-3";
export var eyebrow = "_lg-4";
export var heading = "_lg-5";
export var image = "_lg-f";
export var imagePanel = "_lg-e";
export var modal = "_lg-0";
export var shell = "_lg-1";
export var title = "_lg-6";
export var titleOffer = "_lg-7";